import type {
  ConsumptionValuesVM,
  CostPerUnitVM,
  Offer,
} from '@innogy/become-a-customer/shared/interfaces';
import type { InnogyComponentRendering } from '@core/jss-models';
import { createAction, props } from '@ngrx/store';

import { SHARED_MODAL_PREFIX } from '../../constants';

export const showAomModalAction = createAction(
  `${SHARED_MODAL_PREFIX} Show AOM modal`,
  props<{
    offer: Offer;
    showFooter: boolean;
    rendering: InnogyComponentRendering | undefined;
    consumptionValuesVM: ConsumptionValuesVM | undefined;
    costPerUnitVM?: CostPerUnitVM;
    orderPage?: { href: string };
  }>()
);

export const aomSubmittedAction = createAction(
  `${SHARED_MODAL_PREFIX} AOM modal submitted`,
  props<{
    offer: Offer;
    rendering?: InnogyComponentRendering;
    orderPage?: { href: string };
  }>()
);
